<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>&copy; 2026 <a href="https://gbapp.dev" class="footer-link">gbapp.dev</a> This site only shares guides and news about GB WhatsApp. All rights belong to their owners.</p>
    </div>
    <nav class="footer-links" aria-label="Legal links">
      <a
        v-for="item in legalNavLinks"
        :key="item.href"
        :href="item.href"
        class="footer-link"
      >{{ item.text }}</a>
    </nav>

  </div>
</footer>
</template>

<script>
import { legalNavLinks } from '@/data/sitePages';

export default {
  name: 'Footer',
  data() {
    return {
      legalNavLinks,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  // background-color: #282828;
  background-color: #fff;
  color: #121212;
  padding: 15px 0;
}
@media (max-width: 768px) {
  .footer {
    padding: 10px 0 50px;
  }
}

.footer-container {
  max-width: 1180px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  font-size: 15px;

  p {
    margin: 0;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
  }

  .footer-links {
    justify-content: center;
    margin-bottom: 10px;
  }

  .footer-note {
    font-size: 10px;
  }
}
</style>
